export const keys = {
  builders: () => ['builders'] as const,
  builder: (id: string | number) => ['builders', String(id)] as const,
  communities: (builderId: string | number) => ['builders', String(builderId), 'communities'] as const,
  community: (id: string | number) => ['communities', String(id)] as const,
  communityMtos: (id: string | number) => ['communities', String(id), 'mtos'] as const,
  communityMtoQuantities: (id: string | number) =>
    ['communities', String(id), 'mto-quantities'] as const,
  bid: (communityId: string | number, asOf?: string) =>
    ['communities', String(communityId), 'bid', asOf ?? 'today'] as const,
  bidBreakdown: (mtoFileId: string | number, scope: string, asOf?: string) =>
    ['mtos', String(mtoFileId), 'bid-breakdown', scope, asOf ?? 'today'] as const,
  revisions: (communityId: string | number) => ['communities', String(communityId), 'revisions'] as const,
  mtoLines: (mtoId: string | number) => ['mtos', String(mtoId), 'lines'] as const,
  costedLines: (mtoId: string | number, asOf?: string) =>
    ['mtos', String(mtoId), 'costed-lines', asOf ?? 'today'] as const,
  sameItemMtos: (lineId: number) => ['mto-lines', String(lineId), 'same-item-mtos'] as const,
  mtoPlans: (mtoId: string | number) => ['mtos', String(mtoId), 'plans'] as const,
  modelMargins: (communityId: string | number) =>
    ['communities', String(communityId), 'model-margins'] as const,
  phases: () => ['phases'] as const,
  spendSummary: () => ['spend-mtos', 'summary'] as const,
  poInfo: () => ['po', 'info'] as const,
  poFilters: () => ['po', 'filters'] as const,
  spendAnalysis: (params: string) => ['po', 'spend-analysis', params] as const,
  customerModels: (builderId: string | number) => ['customers', String(builderId), 'models'] as const,
  communityModelAssignments: (communityId: string | number) =>
    ['communities', String(communityId), 'model-assignments'] as const,
  communityUnpriced: (communityId: string | number) =>
    ['communities', String(communityId), 'unpriced'] as const,
  communityAudit: (communityId: string | number) =>
    ['communities', String(communityId), 'audit'] as const,
  laborAnalysis: (communityId: string | number) => ['communities', String(communityId), 'labor-analysis'] as const,
  priceVariance: (qs: string) => ['po', 'price-variance', qs] as const,
  payableTaskGroupPhases: () => ['payable-task-group-phases'] as const,
  phaseQtyPriceItemMaps: () => ['phase-qty-price-item-maps'] as const,
  entities: () => ['entities'] as const,
};
